import { OnInit } from '@angular/core';
import { ShoppingService } from "../../shared/services/shopping.service";
var CartWidgetComponent = /** @class */ (function () {
    function CartWidgetComponent(shopping) {
        this.shopping = shopping;
    }
    CartWidgetComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(CartWidgetComponent.prototype, "total", {
        get: function () {
            if (this.shopping.hasItems) {
                return this.shopping.cartTotal;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    return CartWidgetComponent;
}());
export { CartWidgetComponent };



// WEBPACK FOOTER //
// ./src/app/admin/cart-widget/cart-widget.component.ts.pre-build-optimizer.js